import axios from 'axios';
import apiCache from './apiCache';

/**
 * Small API wrapper around the FastAPI backend. Uses REACT_APP_BACKEND_URL
 * from `.env` (never hardcoded) and prefixes every route with `/api` so
 * the Kubernetes ingress can route to the backend service.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    timeout: 15000,
});

export const api = {
    listSections: (world, lang = 'it') =>
        client
            .get('/sections', {
                params: { ...(world ? { world } : {}), lang },
            })
            .then((r) => r.data),
    // iter90 · Strategia C — section data reads go through apiCache
    // (5min TTL + in-flight dedupe). This makes idle/hover prefetch
    // hit the same cache as click-time fetches. See lib/apiCache.js
    // and lib/sectionPrefetch.js for the full flow.
    getSection: (slug, lang = 'it') => {
        const url = `${API}/sections/${slug}?lang=${encodeURIComponent(lang)}`;
        return apiCache.fetch(url, () =>
            client.get(`/sections/${slug}`, { params: { lang } }).then((r) => r.data),
        );
    },
    getContacts: (lang = 'it') =>
        client
            .get('/settings/contacts', { params: { lang } })
            .then((r) => r.data),
    listEffectPresets: () => client.get('/effect-presets').then((r) => r.data),
    health: () => client.get('/health').then((r) => r.data),
    pageview: (page, session_id, lang = 'it') =>
        client
            .post('/analytics/pageview', {
                page,
                session_id,
                lang,
                referrer: typeof document !== 'undefined' ? document.referrer : '',
            })
            .catch(() => {}),
    // iter70 · Fired by the global click listener in App.js for any
    // element with data-analytics="<event>".
    trackEvent: (event, session_id, lang = 'it', extra = {}) =>
        client
            .post('/analytics/track', { event, session_id, lang, extra })
            .catch(() => {}),
};

export { API };
export default api;
